/* unplugin-vue-components disabled */import script from "./Category.vue?vue&type=script&setup=true&lang=ts"
export * from "./Category.vue?vue&type=script&setup=true&lang=ts"

import "./Category.vue?vue&type=style&index=0&id=13024715&scoped=true&lang=scss"
import "./Category.vue?vue&type=style&index=1&id=13024715&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13024715"]])

export default __exports__